import { render, staticRenderFns } from "./Organisers.vue?vue&type=template&id=5e3dc4c4&scoped=true&"
import script from "./Organisers.vue?vue&type=script&lang=js&"
export * from "./Organisers.vue?vue&type=script&lang=js&"
import style1 from "./Organisers.vue?vue&type=style&index=1&id=5e3dc4c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3dc4c4",
  null
  
)

export default component.exports